/**
 * Small accessibility hardening layer for the current Shopify theme.
 * It only fills missing labels and safe link attributes; it does not change checkout logic.
 */
(function () {
  function hasAccessibleName(element) {
    return Boolean(
      (element.textContent || '').trim() ||
        element.getAttribute('aria-label') ||
        element.getAttribute('aria-labelledby') ||
        element.getAttribute('title')
    );
  }

  function setLabel(selector, label) {
    document.querySelectorAll(selector).forEach((element) => {
      if (!hasAccessibleName(element)) {
        element.setAttribute('aria-label', label);
      }
    });
  }

  function bestCardLabel(link) {
    const card = link.closest('article, .card, [class*="card"], [id*="card"], li, div');
    const heading = card?.querySelector('h1, h2, h3, h4, h5, h6');
    const image = card?.querySelector('img[alt]:not([alt=""])');
    const text = (heading?.textContent || image?.getAttribute('alt') || '').replace(/\s+/g, ' ').trim();

    return text ? `Ver ${text}` : 'Ver detalle';
  }

  function labelStretchedLinks() {
    document.querySelectorAll('a.stretched-link, a[href*="/products/"], a[href*="/blogs/"]').forEach((link) => {
      if (!hasAccessibleName(link)) {
        link.setAttribute('aria-label', bestCardLabel(link));
      }
    });
  }

  function secureExternalLinks() {
    document.querySelectorAll('a[target="_blank"], a[target="ventipay.com"]').forEach((link) => {
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', Array.from(rel).join(' '));
    });
  }

  function applyFixes() {
    setLabel('#main-header-logo, a[href="/"] img', 'Ir al inicio de Benard Fitness');
    setLabel('a[href="/cart"], a[href*="/cart"]', 'Ver carrito');
    setLabel('a[href*="customer_authentication"], a[href*="/account"]', 'Iniciar sesion');
    setLabel('#announcement-bar-dismiss, [data-dismiss]', 'Cerrar aviso');
    setLabel('button[class*="close"], [aria-label="Close popup"], [aria-label="Close dialog"]', 'Cerrar');
    labelStretchedLinks();
    secureExternalLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes);
  } else {
    applyFixes();
  }

  document.addEventListener('shopify:section:load', applyFixes);
})();
